/**
 * @file 本地存储（从 flash -> local storage -> cookie 三层兼容）
 * @author zhujialu
 */
define(function (require) {
    'use strict'

    var storage = BJY.storage

    /**
     * 上次进入教室的日期（非今天）
     *
     * @type {string}
     */
    storage.PREV_ENTER_DATE = 'prev_enter_date'

    /**
     * 摄像头的画面质量
     *
     * @type {string}
     */
    storage.CAMERA_QUALITY = 'camera_quality'

    storage.ASSIST_CAMERA_QUALITY = 'assist_camera_quality'

    /**
     * 摄像头的索引
     *
     * @type {string}
     */
    storage.CAMERA_INDEX = 'camera_index'
    storage.ASSIST_CAMERA_INDEX = 'assist_camera_index'

    /**
     * 麦克风的索引
     *
     * @type {string}
     */
    storage.MIC_INDEX = 'mic_index'

    /**
     * 声道修复选项
     *
     * @type {string}
     */
    storage.AUDIO_REPAIR = 'audio_repair'

    /**
     * 扬声器的索引
     *
     * @type {string}
     */
    storage.SPEAKER_INDEX = 'speaker_index'

    /**
     * 麦克风回音控制
     *
     * @type {string}
     */
    storage.MIC_EC = 'mic_ec'

    /**
     * 麦克风降噪
     *
     * @type {string}
     */
    storage.MIC_NS = 'mic_ns'

    /**
     * 麦克风自动增益
     *
     * @type {string}
     */
    storage.MIC_AGC = 'mic_agc'

    /**
     * 麦克风音量
     *
     * @type {string}
     */
    storage.MIC_VOLUME = 'mic_volume'

    /**
     * 屏幕共享的位置
     * @type {string}
     */
    storage.SHARE_POSITION = 'share_position'

    /**
     * 扬声器音量
     *
     * @type {string}
     */
    storage.SPEAKER_VOLUME = 'speaker_volume'

    /**
     * 美颜降噪
     *
     * @type {string}
     */
    storage.BEAUTIFY_DENOISE = 'beautify_denoise'

    /**
     * 显示点击允许按钮的引导
     *
     * @type {string}
     */
    storage.SHOW_CLICK_ALLOW_GUIDE = 'show_click_allow_guide'

    /**
     * 最开始的新手引导
     *
     * @type {string}
     */
    storage.USER_GUIDE_IN_BEGIN_HAS_SHOW = 'user_guide_in_begin_has_show'

    /**
     * 介绍视频新手引导
     *
     * @type {string}
     */
    storage.USER_GUIDE_VIDEO_GUIDE_HAS_SHOW = 'user_guide_video_guide_has_show'

    /**
     * 一对一开启音视频新手引导
     *
     * @type {string}
     */
    storage.USER_GUIDE_SPEAK_STUDENT = 'user_guide_speak_student'

    /**
     * 老师开启音视频新手引导
     *
     * @type {string}
     */
    storage.USER_GUIDE_SPEAK_TEACHER = 'user_guide_speak_teacher'

    /**
     * 测验新手指导
     *
     * @type {string}
     */
    storage.GUIDE_SHOW_TIMES = 'guide_show_times'

    /**
     * 录制课程的状态
     *
     * @type {string}
     */
    storage.RECORD_CLASS = 'record_class'

    /**
     * 课件图片质量
     *
     * @type {string}
     */
    storage.DOC_QUALITY = 'doc_image_quality'

    /**
     * 传屏新手引导
     *
     * @type {string}
     */
    storage.SHOW_SCREEN_SHARE_GUIDE = 'show_share_desktop_guide'

    /**
     * 系统检测自动打开
     *
     * @type {string}
     */
    storage.AUTO_USE_DETECT_TOOL = 'auto_use_detect_tool'

    /**
     * 是否在自动录课程
     *
     * @type {String}
     */
    storage.IN_AUTO_RECORDING = 'in_auto_recording'

    /**
     * 录课设置
     *
     * @type {string}
     */
    storage.RECORD_SETTINGS = 'record_settings'

    storage.OTHER_SETTINGS = 'other_settings'

    /**
     * 屏幕分享设置
     * @type {string}
     */
    storage.SHARE_SETTINGS = 'share_settings'

    storage.SHOW_CLOUD_RECORD_TIP = 'show_cloud_record_tip'

    storage.SHOW_PUSH_RECORD_TIP = 'show_push_record_tip'

    storage.SELECTED_PROGRAM = 'selected_program'

    storage.LOCK_SCREEN_TIP = 'lock_screen_tip'

    /**
     * 采集系统声音设置
     * @type {string}
     */
    storage.COLLECT_SYSTEM_SOUND_TIP = 'collect_system_sound_tip'

    /**
     * 是否提示麦克风扬声器统一切换
     * @type {string}
     */
    storage.COMBINED_AUDIO_DEVICE_AUTO = 'combined_audio_device_auto'

    /**
     * 系统语言
     * @type {string}
     */
    storage.SYSTEM_LANGUAGE = 'bjy_system_language'

    /**
     * 计时器设置
     * @type {string}
     */
    storage.LAST_TIMER_SET = 'last_time_set'

    /**
     * 清除画笔提示
     * @type {string}
     */
    storage.CLEAR_ALL_SHAPE = 'clear_all_shape'

    return storage
})
